import React from "react";

const TabList = ({ tabs, activeTab, onTabChange }) => {
    return (
        <ul className="list_usage">
            {tabs.map((tab) => (
                <li
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    style={{ borderBottom: activeTab === tab.key ? "2px solid #6F00FF" : "" }}
                    className={`cursor-pointer ${
                        activeTab === tab.key
                            ? "!border-b-2 !border-[#6F00FF] text-[#101828] font-bold"
                            : ""
                    }`}
                >
                    {tab.label}
                </li>
            ))}
        </ul>
    );
};

export default TabList;
